import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { first } from 'rxjs';
import { AuthService } from 'src/services/auth/authentication.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  submitted: boolean = false;
  loginfails: number = 0; // 0 = not fail, 1 = fail not match, 2 = fail authorize
  isPasswordVisible = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authServices: AuthService
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  ngOnInit(): void {
    localStorage.clear();
    this.initialloginForm();
  }

  initialloginForm() {
    this.loginForm = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  togglePasswordVisibility(): void {
      this.isPasswordVisible = !this.isPasswordVisible;
  }

  onSubmit() {
    this.submitted = true;
    if (this.submitted && this.loginForm.invalid) {
      this.loginfails = 1;
    } else {
      this.authServices
        .login(this.loginForm.value.email, this.loginForm.value.password)
        .pipe(first())
        .subscribe({
          next: (res) => {
              this.router.navigate(['/']);
          },
          error: (error) => {
            let errors = error;
            if(errors.status == 401) {
              this.loginfails = 2;
            }else{
            this.loginfails = 1;
            }
            return;
            // Swal.fire({
            //   icon: 'error',
            //   title: 'Username or password incorrect',
            //   showConfirmButton: true,
            // });
          },
        });
    }
  }
}
